import React from "react";

export function convertUnitsToSuperscript(units: string): React.ReactNode {
  if (units.includes("^")) {
    const parts = units.split(/(\^[\d.]+)/);
    const superscriptedParts = parts.map((part, index) => {
      if (/^\^[\d.]+$/.test(part)) {
        // Render superscripted numbers inside a <sup> tag
        return (
          <React.Fragment key={index}>
            <sup key={index}>{part.slice(1)}</sup>
          </React.Fragment>
        );
      }
      // Render all other parts as-is
      return part;
    });
    return <>{superscriptedParts}</>;
  }
  return units;
}

// Add the formatFileSize function here
export function formatFileSize(bytes: number): string {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(2)} ${units[unitIndex]}`;
}
